import { Col, Row } from 'reactstrap'
import { H4 } from '../../../../../AbstractElements'
import { SearchPixelStrap } from '../../../../../Utils/Constants'
import { searchTabsData } from '../../../../../Data/Application/SearchResult/SearchResult'
import InformationCommon from './InformationCommon'
import PagesSort from './PagesSort'

const AllTabs = () => {
  return (
    <>
      <H4 className="mb-2">{SearchPixelStrap}</H4>
      <Row className="gy-3">
        {searchTabsData.map((item, i) => (
          <Col xxl="6" xl="6" key={i} className="box-col-12">
            <InformationCommon item={item} />
          </Col>
        ))}
      </Row>
      <PagesSort />
    </>
  )
}

export default AllTabs